import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconWarningSolid } from '@wegic/icon';
import { Ball } from '@wegic/ui';
import '@wegic/ui/dist/components/Ball/index.css';
import classNames from 'classnames';
import { useMemo } from 'react';
import { PublishStatus as PublishStatusEnum } from '@/services/project';
import styles from './index.module.less';
export default function PublishStatusBadge(props) {
    const { status, customDomainRemind = false, className, shape = 'round' } = props;
    const DATA = useMemo(()=>{
        if (status === PublishStatusEnum.NotPublished) {
            return {
                icon: /*#__PURE__*/ _jsx(Ball, {
                    type: "black"
                }),
                text: intl.get('workspace.project.status.unpublished')
            };
        }
        if (customDomainRemind) {
            return {
                icon: /*#__PURE__*/ _jsx("span", {
                    style: {
                        color: '#F7AA1A',
                        fontSize: '16px',
                        margin: '0 4px'
                    },
                    children: /*#__PURE__*/ _jsx(IconWarningSolid, {
                        fontSize: 16
                    })
                }),
                text: intl.get('workspace.project.status.expire')
            };
        }
        if (status === PublishStatusEnum.Published) {
            return {
                icon: /*#__PURE__*/ _jsx(Ball, {
                    type: "green"
                }),
                text: intl.get('workspace.project.status.published')
            };
        }
        if (status === PublishStatusEnum.WaitUpdate) {
            return {
                icon: /*#__PURE__*/ _jsx(Ball, {
                    type: "yellow",
                    breath: true
                }),
                text: intl.get('workspace.project.status.update')
            };
        }
        return {
            icon: /*#__PURE__*/ _jsx(Ball, {
                type: "black"
            }),
            text: intl.get('workspace.project.status.unpublished')
        };
    }, [
        status,
        customDomainRemind
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles['publish-status'],
        children: [
            DATA.icon,
            /*#__PURE__*/ _jsx("div", {
                className: classNames({
                    [styles.text]: true,
                    [styles.publish]: status === PublishStatusEnum.Published,
                    [styles.expire]: customDomainRemind,
                    [styles.update]: status === PublishStatusEnum.WaitUpdate,
                    [styles.hide]: shape === 'circle'
                }, className),
                children: DATA.text
            })
        ]
    });
}
